import { createTheme } from '@material-ui/core/styles';

import { palette } from './palette';

export const darkTheme = createTheme({ palette });
